import { isProviderRole, normalizePublicNumber, providerLabel } from '../../../shared/provider-label';
/**
 * The name this account shows in a call room: the participant tile, the
 * participant list, chat and the caption speaker prefix.
 *
 * An interpreter or captioner is shown to the people they serve by ID,
 * "Interpreter #1042", never by name (Robert, 2026-10-05,
 * shared/provider-label.js). The server signs the same label into their room
 * token. A Jobs room (job-*) is a staff surface and keeps the name, as its
 * token does. Anyone else shows their account name.
 *
 * @param user - The cached account (vrs_user_info).
 * @param role - The signed-in role (getUserRole()), which wins over user.role.
 * @param roomName - The room, when known.
 * @returns The name, or undefined when there is none to show.
 */
export function roomDisplayName(user, role, roomName) {
    const accountRole = role || user?.role;
    const jobsRoom = String(roomName || '').toLowerCase().startsWith('job-');
    if (isProviderRole(accountRole) && !jobsRoom) {
        return providerLabel(accountRole, user?.publicNumber);
    }
    const name = user?.name || user?.displayName || user?.username || user?.email || '';
    return name.trim() || undefined;
}
/**
 * The public number an auth_success carries, merged into the cached account
 * when it belongs to the same interpreter or captioner. Returns the new cache
 * value, or null when nothing changes.
 *
 * @param user - The cached account (vrs_user_info).
 * @param message - The auth_success message: role, userId, publicNumber.
 */
export function withPublicNumber(user, message) {
    if (!user || !isProviderRole(message.role) || !('publicNumber' in message)) {
        return null;
    }
    if (message.userId && user.id && String(user.id) !== String(message.userId)) {
        return null;
    }
    const publicNumber = normalizePublicNumber(message.publicNumber);
    return user.publicNumber === publicNumber ? null : { ...user, publicNumber };
}
